import styled from 'styled-components';
import { Select } from 'components/atoms/select';

export const StyledSelect = styled(Select)`
  .ozone-select__control {
    display: flex;
    flex: 1;
  }
`;
